"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PLOT_MAXIMUM: function() {
        return PLOT_MAXIMUM;
    },
    MAX_MESSAGE: function() {
        return MAX_MESSAGE;
    },
    TestPickerStateController: function() {
        return TestPickerStateController;
    }
});
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _query = require("../../../infra-sk/modules/query");
const _errorMessage = require("../../../elements-sk/modules/errorMessage");
const _const = require("../const/const");
const _testpicker = require("../common/test-picker");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const PLOT_MAXIMUM = 200;
const MAX_MESSAGE = 'Reduce Traces';
let TestPickerStateController = class TestPickerStateController {
    startNewCascade() {
        var _this_abortController;
        (_this_abortController = this.abortController) === null || _this_abortController === void 0 ? void 0 : _this_abortController.abort();
        this.abortController = new AbortController();
        return ++this.activeCascadeId;
    }
    hostConnected() {}
    /**
   * Initializes Test Picker from scratch.
   */ async initializeTestPicker(params, defaultParams, readOnly, forceManualPlot = false) {
        this.startNewCascade();
        this.initialParams = params;
        this.forceManualPlot = forceManualPlot;
        this.defaultParams = defaultParams;
        this.initializeFieldData(params);
        await this.addChildField(readOnly);
    }
    /**
   * Resets data structures from scratch.
   */ initializeFieldData(params) {
        this.currentIndex = 0;
        this.fieldData = params.map((param, i)=>({
                param: param,
                value: i === 0 ? [] : null,
                options: [],
                selectedItems: [],
                split: false,
                splitDisabled: false,
                disabled: false,
                splitBy: [],
                index: i
            }));
        this.host.requestUpdate();
    }
    /**
   * Generates a query string from the currently selected field values.
   */ createQueryFromFieldData() {
        return (0, _query.fromParamSet)(this.createParamSetFromFieldData());
    }
    createParamSetFromFieldData() {
        const paramSet = {};
        if (this.fieldData.length === 0 || this.fieldData[0].value === null) {
            return {};
        }
        this.fieldData.forEach((fieldInfo)=>{
            if (fieldInfo.value !== null) {
                paramSet[fieldInfo.param] = fieldInfo.value.map((v)=>v === _testpicker.DEFAULT_OPTION_LABEL || v === '' ? _const.MISSING_VALUE_SENTINEL : v);
            }
        });
        if (Object.keys(paramSet).length === 0) {
            return {};
        }
        if ((this.fieldData[0].value || []).length === 0) {
            return {};
        }
        for(const defaultParamKey in this.defaultParams){
            if (!(defaultParamKey in paramSet)) {
                paramSet[defaultParamKey] = this.defaultParams[defaultParamKey];
            }
        }
        return paramSet;
    }
    createQueryFromIndex(index) {
        var _this_fieldData_;
        const paramSet = {};
        for(let i = 0; i <= index; i++){
            const fieldInfo = this.fieldData[i];
            if (fieldInfo && fieldInfo.value !== null) {
                paramSet[fieldInfo.param] = fieldInfo.value.map((v)=>v === _testpicker.DEFAULT_OPTION_LABEL || v === '' ? _const.MISSING_VALUE_SENTINEL : v);
            }
        }
        if (Object.keys(paramSet).length === 0) {
            return '';
        }
        if ((((_this_fieldData_ = this.fieldData[0]) === null || _this_fieldData_ === void 0 ? void 0 : _this_fieldData_.value) || []).length === 0) {
            return '';
        }
        for(const defaultParamKey in this.defaultParams){
            if (!(defaultParamKey in paramSet)) {
                paramSet[defaultParamKey] = this.defaultParams[defaultParamKey];
            }
        }
        return (0, _query.fromParamSet)(paramSet);
    }
    setReadOnly(readonly, overrideDataLoadingCheck = false) {
        var _exploreMulti;
        if (this.readOnly === readonly) {
            return;
        }
        const exploreMulti = document.querySelector('explore-multi-sk');
        if (exploreMulti && exploreMulti._dataLoading && !overrideDataLoadingCheck) {
            readonly = true;
        }
        this.dataLoading = ((_exploreMulti = exploreMulti) === null || _exploreMulti === void 0 ? void 0 : _exploreMulti._dataLoading) || false;
        this.readOnly = readonly;
        this.fieldData = this.fieldData.map((field)=>_object_spread_props(_object_spread({}, field), {
                disabled: readonly
            }));
        this.host.requestUpdate();
    }
    updateCount(count, hasGraphLoaded = false) {
        if (count === -1) {
            if (this.currentIndex > 0) {
                this.setReadOnly(true);
            } else {
                this.setReadOnly(false);
            }
            this.count = 0;
            this.host.requestUpdate();
            return;
        }
        this.setReadOnly(false);
        this.count = count;
        if (count > PLOT_MAXIMUM || count <= 0) {
            this.autoAddTrace = false;
            this.host.requestUpdate();
            return;
        }
        if (hasGraphLoaded && !this.forceManualPlot) {
            this.autoAddTrace = true;
        } else {
            this.autoAddTrace = false;
        }
        this.host.requestUpdate();
    }
    async callNextParamList(handler, index, hasGraphLoaded = false, cascadeId = this.activeCascadeId) {
        var _this_abortController, _this_fieldData_index;
        if (cascadeId !== this.activeCascadeId) {
            return false;
        }
        const signal = (_this_abortController = this.abortController) === null || _this_abortController === void 0 ? void 0 : _this_abortController.signal;
        const requestId = ++this.currentRequestId;
        this.updateCount(-1, hasGraphLoaded);
        this.requestInProgress = true;
        if (!((((_this_fieldData_index = this.fieldData[index]) === null || _this_fieldData_index === void 0 ? void 0 : _this_fieldData_index.value) || []).length > 1)) {
            this.setReadOnly(true);
        }
        const fieldDataQuery = this.createQueryFromIndex(index);
        const body = {
            q: fieldDataQuery
        };
        try {
            const response = await fetch('/_/nextParamList/', {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json'
                },
                signal
            });
            const json = await (0, _jsonOrThrow.jsonOrThrow)(response);
            if (requestId !== this.currentRequestId || cascadeId !== this.activeCascadeId) {
                // Discard stale out-of-order response if a newer request or cascade has started.
                return false;
            }
            await handler(json);
            return requestId === this.currentRequestId && cascadeId === this.activeCascadeId;
        } catch (msg) {
            var _signal, _msg;
            if (((_signal = signal) === null || _signal === void 0 ? void 0 : _signal.aborted) || ((_msg = msg) === null || _msg === void 0 ? void 0 : _msg.name) === 'AbortError') {
                return false;
            }
            if (requestId === this.currentRequestId && cascadeId === this.activeCascadeId) {
                this.removeChildFields(index);
                (0, _errorMessage.errorMessage)(msg);
            }
            return false;
        } finally{
            if (requestId === this.currentRequestId) {
                this.requestInProgress = false;
                this.setReadOnly(false);
                this.host.requestUpdate();
            }
        }
    }
    async addChildField(readOnly, hasGraphLoaded = false) {
        const cascadeId = this.startNewCascade();
        const currentIndex = this.currentIndex;
        const currentFieldInfo = this.fieldData[currentIndex];
        const param = currentFieldInfo.param;
        const handler = async (json)=>{
            if (cascadeId !== this.activeCascadeId) {
                return;
            }
            this.updateCount(json.count, hasGraphLoaded);
            if (param in json.paramset && json.paramset[param] !== null) {
                var _document_querySelector, _defaults;
                let options = json.paramset[param].filter((option)=>!option.includes('.'));
                options = options.map((o)=>o === '' ? _testpicker.DEFAULT_OPTION_LABEL : o);
                options.sort((a, b)=>a.localeCompare(b, 'en', {
                        sensitivity: 'base'
                    }));
                const extraTests = json.paramset[param].filter((option)=>option.includes('.'));
                if (extraTests.length > 0) {
                    options = options.concat(extraTests);
                }
                this.fieldData[currentIndex].options = options;
                this.fieldData = [
                    ...this.fieldData
                ];
                this.setReadOnly(readOnly);
                this.currentIndex += 1;
                this.host.setFieldPendingFocus(param);
                if (currentIndex !== 0) {
                    this.host.setFieldPendingOpenOverlay(param);
                }
                const defaults = (_document_querySelector = document.querySelector('explore-multi-sk')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.defaults;
                if (((_defaults = defaults) === null || _defaults === void 0 ? void 0 : _defaults.default_trigger_priority) && defaults.default_trigger_priority[param] && currentFieldInfo.value && currentFieldInfo.value.length === 0) {
                    const priorityList = defaults.default_trigger_priority[param];
                    for (const priorityVal of priorityList){
                        if (options.includes(priorityVal)) {
                            await this.host.handleValueChangeForField(currentIndex, [
                                priorityVal
                            ], false, hasGraphLoaded);
                            break;
                        }
                    }
                }
            } else {
                this.currentIndex += 1;
            }
            if (cascadeId === this.activeCascadeId) {
                this.host.requestUpdate();
            }
        };
        await this.callNextParamList(handler, currentIndex, hasGraphLoaded, cascadeId);
    }
    removeChildFields(index) {
        while(this.currentIndex > index + 1){
            this.currentIndex -= 1;
            if (this.currentIndex < this.fieldData.length) {
                const fieldInfo = this.fieldData[this.currentIndex];
                if (fieldInfo.splitBy.length > 0) {
                    fieldInfo.split = false;
                    this.host.dispatchEvent(new CustomEvent('split-by-changed', {
                        detail: {
                            param: fieldInfo.param,
                            split: false
                        },
                        bubbles: true,
                        composed: true
                    }));
                }
                fieldInfo.value = null;
                fieldInfo.selectedItems = [];
                fieldInfo.options = [];
            }
        }
        if (this.fieldData[index]) {
            this.fieldData[index].value = [];
            this.fieldData[index].selectedItems = [];
        }
        this.fieldData = [
            ...this.fieldData
        ];
        this.host.requestUpdate();
    }
    setSplitFields(param, split) {
        if (split) {
            const alreadySplit = this.fieldData.find((f)=>f.splitBy.length > 0 && f.param !== param);
            if (alreadySplit) {
                const currentField = this.fieldData.find((f)=>f.param === param);
                if (currentField) {
                    currentField.split = false;
                }
                this.fieldData = [
                    ...this.fieldData
                ];
                this.host.requestUpdate();
                return;
            }
        }
        this.setReadOnly(true);
        this.fieldData = this.fieldData.map((field)=>{
            if (field.param === param) {
                return _object_spread_props(_object_spread({}, field), {
                    split,
                    splitBy: split ? [
                        param
                    ] : []
                });
            } else {
                return _object_spread_props(_object_spread({}, field), {
                    split: split ? false : field.split,
                    splitDisabled: split
                });
            }
        });
        this.host.requestUpdate();
    }
    async fetchExtraOptions(index, hasGraphLoaded = false, cascadeId = this.activeCascadeId) {
        if (cascadeId !== this.activeCascadeId) {
            return false;
        }
        const handler = async (json)=>{
            if (cascadeId !== this.activeCascadeId) {
                return;
            }
            const param = Object.keys(json.paramset)[0];
            const count = json.count || -1;
            if (param !== undefined) {
                for(let i = 0; i < this.fieldData.length; i++){
                    const fieldInfo = this.fieldData[i];
                    if (fieldInfo.param === param) {
                        var _document_querySelector, _defaults;
                        let options = json.paramset[param].filter((option)=>!option.includes('.')).map((o)=>o === '' ? _testpicker.DEFAULT_OPTION_LABEL : o);
                        const extraTests = json.paramset[param].filter((option)=>option.includes('.'));
                        if (extraTests.length > 0) {
                            options = options.concat(extraTests);
                        }
                        fieldInfo.options = options;
                        fieldInfo.index = i;
                        let isNewField = false;
                        let valueChanged = false;
                        if (fieldInfo.value === null) {
                            isNewField = true;
                            fieldInfo.value = [];
                        } else {
                            const validValues = fieldInfo.value.filter((v)=>options.includes(v));
                            if (validValues.length !== fieldInfo.value.length) {
                                fieldInfo.value = validValues;
                                fieldInfo.selectedItems = validValues;
                                valueChanged = true;
                            }
                        }
                        this.fieldData = [
                            ...this.fieldData
                        ];
                        if (valueChanged && fieldInfo.value.length === 0) {
                            this.removeChildFields(i);
                        }
                        if (!hasGraphLoaded) {
                            this.host.setFieldPendingFocus(param);
                            if (isNewField && i > 0) {
                                this.host.setFieldPendingOpenOverlay(param);
                            }
                        }
                        const defaults = (_document_querySelector = document.querySelector('explore-multi-sk')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.defaults;
                        if (((_defaults = defaults) === null || _defaults === void 0 ? void 0 : _defaults.default_trigger_priority) && defaults.default_trigger_priority[param] && fieldInfo.value.length === 0) {
                            const priorityList = defaults.default_trigger_priority[param];
                            for (const priorityVal of priorityList){
                                if (options.includes(priorityVal)) {
                                    await this.host.handleValueChangeForField(i, [
                                        priorityVal
                                    ], false, hasGraphLoaded);
                                    break;
                                }
                            }
                        } else if (fieldInfo.value.length > 0) {
                            // Self-propagating recursive cascade: The backend query for `index` returns the
                            // subsequent parameter key `param` (matching downstream field `i = index + 1`).
                            // If this downstream field already has pre-populated values, recursively invoke
                            // fetchExtraOptions(i) to fetch options for the next downstream field (i + 1).
                            if (cascadeId === this.activeCascadeId) {
                                await this.fetchExtraOptions(i, hasGraphLoaded, cascadeId);
                            }
                        }
                        // Post-await guard: ensure cascadeId is still active before mutating currentIndex or calling updateCount.
                        if (cascadeId !== this.activeCascadeId) {
                            return;
                        }
                        if (this.currentIndex <= i + 1) {
                            this.currentIndex = i + 1;
                            this.updateCount(count, hasGraphLoaded);
                        }
                        break;
                    }
                }
            } else {
                if (this.currentIndex <= this.fieldData.length) {
                    this.currentIndex = this.fieldData.length;
                    this.updateCount(count, hasGraphLoaded);
                }
            }
            if (cascadeId === this.activeCascadeId) {
                this.host.requestUpdate();
            }
        };
        return await this.callNextParamList(handler, index, hasGraphLoaded, cascadeId);
    }
    async populateFieldDataFromQuery(query, params, paramSet, hasGraphLoaded = true) {
        const cascadeId = this.startNewCascade();
        const selectedParams = (0, _query.toParamSet)(query);
        if (paramSet && Object.keys(paramSet).length > 0) {
            const paramKeys = Object.keys(paramSet).filter((key)=>key in selectedParams);
            this.initializeFieldData(paramKeys);
        } else {
            this.initializeFieldData(params);
        }
        for(let i = 0; i < this.fieldData.length; i++){
            const fieldInfo = this.fieldData[i];
            const param = fieldInfo.param;
            let selectedValue = selectedParams[fieldInfo.param] || [];
            selectedValue = selectedValue.map((v)=>v === _const.MISSING_VALUE_SENTINEL || v === '' ? _testpicker.DEFAULT_OPTION_LABEL : v);
            fieldInfo.selectedItems = selectedValue;
            fieldInfo.value = selectedValue;
            if (paramSet && paramSet[param]) {
                fieldInfo.options = paramSet[param];
            }
            fieldInfo.index = i;
        }
        this.fieldData = [
            ...this.fieldData
        ];
        // fetchExtraOptions(0) initiates a sequential cascade across all pre-populated fields.
        // Inside fetchExtraOptions, the query for field 0 returns options for field 1. If field 1
        // already has a selected value, fetchExtraOptions recursively invokes itself for index 1
        // (see line 424). This self-propagating chain sequentially populates options for all
        // downstream fields (0 -> 1 -> 2 -> ... -> N) without requiring an outer for...await loop
        // or triggering parallel fetch storms.
        if (this.fieldData.length > 0) {
            await this.fetchExtraOptions(0, hasGraphLoaded, cascadeId);
        }
    }
    async populateFieldDataFromParamSet(paramSets, paramSet, splitByKeys = [], hasGraphLoaded = true) {
        const cascadeId = this.startNewCascade();
        const uniqueParamKeys = [
            ...new Set([
                ...Object.keys(paramSets),
                ...Object.keys(paramSet)
            ])
        ];
        const filteredKeys = this.initialParams.filter((key)=>uniqueParamKeys.includes(key));
        this.initializeFieldData(filteredKeys);
        this.currentIndex = 0;
        if (Object.keys(paramSet).length === 0 && !this.forceManualPlot) {
            this.autoAddTrace = true;
        }
        for(let i = 0; i < this.fieldData.length; i++){
            const fieldInfo = this.fieldData[i];
            const param = fieldInfo.param;
            if (splitByKeys.includes(param)) {
                fieldInfo.split = true;
                fieldInfo.splitBy = [
                    param
                ];
            }
            let value = paramSets[param] || [];
            value = value.map((v)=>v === _const.MISSING_VALUE_SENTINEL || v === '' ? _testpicker.DEFAULT_OPTION_LABEL : v);
            const allOptions = [
                ...new Set([
                    ...value,
                    ...paramSet[param] || []
                ])
            ].sort();
            if (value.length === 0) {
                break;
            }
            if (allOptions.length > 0) {
                fieldInfo.options = allOptions;
                fieldInfo.selectedItems = value;
                fieldInfo.index = i;
                fieldInfo.value = value;
            }
        }
        this.fieldData = [
            ...this.fieldData
        ];
        // See comment in populateFieldDataFromQuery regarding fetchExtraOptions(0) sequential cascading.
        if (this.fieldData.length > 0) {
            await this.fetchExtraOptions(0, hasGraphLoaded, cascadeId);
        }
    }
    isLoaded() {
        return this.fieldData.length > 0 && this.fieldData[0].selectedItems && this.fieldData[0].selectedItems.length > 0;
    }
    constructor(host){
        this.fieldData = [];
        this.count = -1;
        this.requestInProgress = false;
        this.currentIndex = 0;
        this.defaultParams = {};
        this.autoAddTrace = false;
        this.readOnly = false;
        this.dataLoading = false;
        this.forceManualPlot = false;
        this.initialParams = [];
        this.currentRequestId = 0;
        this.activeCascadeId = 0;
        this.abortController = null;
        (this.host = host).addController(this);
    }
};
